import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import StarRating from './StarRating';
import { getReviews } from '../lib/api/reviewsApi';

// Section preuve sociale : moyenne + avis récents (avec commentaire). Cachée tant qu'il n'y a aucun avis.
function Reviews() {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState(null);

  const fmtDate = (iso) =>
    new Date(iso).toLocaleDateString(i18n.resolvedLanguage || 'fr', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });

  useEffect(() => {
    let alive = true;
    getReviews()
      .then(({ data: d }) => alive && setData(d))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  if (!data || !data.count) return null;

  const withComment = (data.items || []).filter((r) => r.comment).slice(0, 6);

  return (
    <section className="reviews">
      <div className="reviews__head">
        <span className="reviews__eyebrow">{t('reviews.section_eyebrow')}</span>
        <div className="reviews__score">
          <StarRating value={data.average} readOnly size="lg" />
          <span className="reviews__avg">{data.average.toFixed(1)}/5</span>
        </div>
        <span className="reviews__count">{t('reviews.count', { count: data.count })}</span>
      </div>

      {withComment.length > 0 && (
        <div className="reviews__list">
          {withComment.map((r) => (
            <blockquote key={r.id} className="reviews__card">
              <StarRating value={r.rating} readOnly size="sm" />
              <p className="reviews__text">“{r.comment}”</p>
              <footer className="reviews__foot">
                <cite className="reviews__author">{r.authorName || t('reviews.anon')}</cite>
                <span className="reviews__date">{fmtDate(r.createdAt)}</span>
              </footer>
            </blockquote>
          ))}
        </div>
      )}

      <a className="reviews__all" href="/avis">{t('reviews.see_all')} →</a>
    </section>
  );
}

export default Reviews;
